export default __webpack_public_path__ + "static/small-image-richinstead-2-1cc993de44f830b0ec7cb8ef0aa758d4.png";